var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomizeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11667 14V10.25H8.11667V11.6333H14V12.6333H8.11667V14H7.11667ZM2 12.6333V11.6333H6.11667V12.6333H2ZM5.11667 9.86667V8.5H2V7.5H5.11667V6.1H6.11667V9.86667H5.11667ZM7.11667 8.5V7.5H14V8.5H7.11667ZM9.88333 5.75V2H10.8833V3.36667H14V4.36667H10.8833V5.75H9.88333ZM2 4.36667V3.36667H8.88333V4.36667H2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizeIcon);
export default __webpack_public_path__ + "static/media/customize-icon.1908559995df9747dd018db7ea6c3f04.svg";
export { ForwardRef as ReactComponent };